import { Observable } from 'rxjs';
import { ChatMessage, ChatThread } from '@models';

export abstract class ChatService {
  abstract getMessages(threadId: string): Observable<ChatMessage[]>;
  abstract sendMessage(threadId: string, text: string): Observable<void>;
  abstract markThreadAsRead(threadId: string): Observable<void>;
  abstract watchMessages(threadId: string): Observable<ChatMessage[]>;
  abstract getThreads(): Observable<ChatThread[]>;
  abstract watchThreads(): Observable<ChatThread[]>;
}
